import SessionAPIUtils from 'bundles/author-course/utils/CourseSessionAPIUtils';

export const getLearnerItemSchedule = (
  actionContext: $TSFixMe,
  { groupId, userId, sessionId }: $TSFixMe,
  done: $TSFixMe
) => {
  const promise = SessionAPIUtils.getLearnerItemSchedule({ sessionId, userId })
    .then((response: $TSFixMe) => {
      actionContext.dispatch('RECEIVE_LEARNER_ITEM_SCHEDULE', {
        userId,
        schedule: response.elements[0],
        sessionId,
      });
    })
    .catch((err: $TSFixMe) => {
      actionContext.dispatch('FAIL_RECEIVE_LEARNER_ITEM_SCHEDULE', { sessionId });
    })
    .then(done);

  promise.done();
  return promise;
};

export const saveOverriddenSessionToServer = (
  actionContext: $TSFixMe,
  { session, userId, shouldLoadLearnerItemSchedule }: $TSFixMe,
  done: $TSFixMe
) => {
  const { originalSession } = session;
  const sessionId = originalSession.id;

  actionContext.dispatch('START_LEARNER_SAVE_SESSION_TO_SERVER', { userId });

  const promise = SessionAPIUtils.updateLearnerItemSchedule({ sessionId, userId, sessionOverrides: session.overrides })
    .then((response: $TSFixMe) => {
      // PARTNER-17844, load updated learner item schedule before unmarking session as modified
      // so that the saved session scheule and deadlines don't revert to previous settings in the UI
      if (shouldLoadLearnerItemSchedule) {
        actionContext.dispatch('RECEIVE_LEARNER_ITEM_SCHEDULE', {
          userId,
          schedule: response.elements[0],
          sessionId,
        });
      }
      actionContext.dispatch('SAVED_SESSION_TO_SERVER', {
        sessionId,
        sessionData: null,
        userId,
      });
    })
    .catch((err: $TSFixMe) => {
      actionContext.dispatch('FAILED_TO_SAVE_SESSION_TO_SERVER', { userId });
    })
    .then(done);

  promise.done();
  return promise;
};

export const updateLearnerItemDeadline = (
  actionContext: $TSFixMe,
  { sessionId, itemId, deadlineMoment }: $TSFixMe,
  done: $TSFixMe
) => {
  // update overridden session item for patch changes
  actionContext.dispatch('UPDATE_LEARNER_ITEM_DEADLINE_MOMENT', {
    sessionId,
    itemId,
    deadlineMoment,
  });

  // also update session item for consistency
  actionContext.dispatch('UPDATE_SESSION_ITEM_DEADLINE_MOMENT', {
    sessionId,
    itemId,
    deadlineMoment,
  });
};

export const updateLearnerItemSchedule = (
  actionContext: $TSFixMe,
  { sessionId, itemId, unlockTime, relockTime }: $TSFixMe,
  done: $TSFixMe
) => {
  actionContext.dispatch('UPDATE_LEARNER_ITEM_SCHEDULE', {
    sessionId,
    itemId,
    unlockTime,
    relockTime,
  });

  actionContext.dispatch('UPDATE_SESSION_ITEM_SCHEDULE', {
    sessionId,
    itemId,
    unlockTime,
    relockTime,
  });
};

export const deleteLearnerItemSchedule = (actionContext: $TSFixMe, { sessionId, itemId }: $TSFixMe, done: $TSFixMe) => {
  actionContext.dispatch('DELETE_LEARNER_ITEM_SCHEDULE', {
    sessionId,
    itemId,
  });

  actionContext.dispatch('DELETE_SESSION_ITEM_SCHEDULE', {
    sessionId,
    itemId,
  });
};

export const clearLearnerItemSchedule = (actionContext: $TSFixMe, { sessionId }: $TSFixMe, done: $TSFixMe) => {
  actionContext.dispatch('CLEAR_LEARNER_ITEM_SCHEDULE', {
    sessionId,
  });
};
